export const toCurrency = (num) => {
    if (!num) return '0.00'
    const number = parseFloat(num)

    return number
        ?.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true,

        })
        .replace(/,/g, '.')
}
